import { ArgsType } from '@nestjs/graphql'
import { BaseGetByIdArgs } from '../base/baseGetById.args'

@ArgsType()
export class CategoryGetByIdArgs extends BaseGetByIdArgs<CategoryGetByIdArgs> { }
